import { Button, Modal, Spinner } from "react-bootstrap";
import { useCallback, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { format } from "date-fns";

import { updateUserMutation } from "../services/wp.user.service";
import { useAuth } from "../services/wp.auth.service";
import { useNotifications } from "./NotificationsContext";

const WaiverAgreementPopup = ({
	show
}) => {

	const { user } = useAuth();
	const { addNotification } = useNotifications();
	const [loading, setLoading] = useState(false);
	const queryClient = useQueryClient();

	const {
		mutateAsync: acceptTerms
	} = updateUserMutation(useMutation);

	const handleAgree = useCallback(async (evt) => {
		setLoading(true);
		evt.preventDefault();

		const termsAgreedTs = format(new Date(), "yyyy-MM-dd HH:mm:ss");
		const userInput = {
			id: user.databaseId,
			accountStatus: {
				termsAgreedTs
			}
		};

		try {
			await acceptTerms(userInput);
			addNotification({
				message: "You have successfully agreed to the Life With Cancer terms of use and waivers.",
				type: "success"
			});
			await queryClient.refetchQueries("auth-user");
		} catch (error) {
			addNotification({
				message: error.message,
				type: "danger"
			});
		}
		setLoading(false);
	}, []);

	return (
		<Modal centered show={Boolean(show)} size="lg">
			<Modal.Body className="p-5">
				<h2>Waivers and Terms of Use</h2>
				{show === "newTerms" && window.lwcSiteSettings.waivers.update_message
					? <div dangerouslySetInnerHTML={{ __html: window.lwcSiteSettings.waivers.update_message }} />
					: show === "annual"
						/* eslint-disable-next-line max-len */
						? <div dangerouslySetInnerHTML={{ __html: window?.lwcSiteSettings?.waivers?.yearly_message || "Set message in WordPress Admin Options." }} />
						: null}
				<p>Please review the following waivers and terms:</p>
				<ul>
					<li><Link target="_blank" to="/general-waiver">General Waiver</Link></li>
					<li><Link target="_blank" to="/physical-activity-waiver">Physical Activity Waiver</Link></li>
				</ul>
				<p>By clicking the &apos;I Agree&apos; button, I agree to be bound by the terms listed above.</p>
			</Modal.Body>
			<Modal.Footer className="text-right">
				<Button onClick={handleAgree} variant="success">{loading ? <Spinner animation="border" size="sm" /> : "I Agree"}</Button>
			</Modal.Footer>
		</Modal>
	);
};

WaiverAgreementPopup.propTypes = {
	show: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired
};

export default WaiverAgreementPopup;
